import { Outlet, createFileRoute } from '@tanstack/react-router'
import { fetchSearchAgentThreads } from '@/api/agents/searchAgent'

export const Route = createFileRoute('/_auth/$orgSlug/$projectId/search-agent')({
  loader: async ({ params }) => {
    const projectId = parseInt(params.projectId, 10)
    const { threads } = await fetchSearchAgentThreads(projectId)
    return { threads }
  },
  component: SearchAgentLayout
})

function SearchAgentLayout() {
  return (
    <div className="flex h-full flex-col">
      <Outlet />
    </div>
  )
}
